import loadable from '@loadable/component'

export const LazyFacebookEmbed = loadable(() => import('./Facebook.web'))
